export const HYBRID_SPACE_OPACITY = 50;
export const DEFAULT_SPACE_OPACITY = 100;

export function defaultSpaceOpacity(isHybridPathway: boolean): number {
  return isHybridPathway ? HYBRID_SPACE_OPACITY : DEFAULT_SPACE_OPACITY;
}

export function applySpaceOpacity(
  baseOpacity: number,
  spaceOpacityPercent = DEFAULT_SPACE_OPACITY
): number {
  return (baseOpacity * spaceOpacityPercent) / 100;
}
